import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QuizQuestion } from 'src/app/models';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';

@Component({
  selector: 'app-module5-rw',
  templateUrl: './module5-rw.component.html',
  styleUrls: ['./module5-rw.component.css', '../rentwise.component.css']
})
export class Module5RwComponent implements OnInit {

  module = 5;
  page = 1;

  // Contains all questions for the module
  questions: QuizQuestion[] = [];

  constructor(private courseService: CoursesService, private router: Router, private quizService: QuizService) { }

  ngOnInit(): void {
    this.courseService.setCurrentCourseBy('RentWise');

    // Open the furthest page
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      this.page = this.courseService.currentCourse.furthestPageID + 1;
    }

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f34403fadf713839b08cdd").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });
  }

  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < this.module) {
      this.courseService.updateFurthestModule().toPromise().then((res: any) => {
        console.log(res);
      });
    }
  }

  // Update furthestPageID
  updatePageProgress() {
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      if (this.courseService.currentCourse.furthestPageID < this.page) {
        this.courseService.updateFurthestPage(this.page).toPromise();
      }
    }
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
      this.router.navigate(['/module6-rw']);
    }

    // Review
    else {
      this.page = 1
    }
  }

  next(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.page += 1;
    window.scrollTo(0,0);
    this.updatePageProgress();
    return true;
  }

  back(){
    this.page -= 1;
    window.scrollTo(0,0);
    return true;
  }
}
